<div class="position-relative w-100 h-100 overflow-hidden">
  <div
    #mapContainer
    class="brouter-map__canvas w-100 h-100"
    data-testid="brouter-map-canvas"
    [class.brouter-map__canvas--drawing]="drawMode() && !readonlyMap()"
  ></div>

  @if (isReady()) {
    <!-- Spans the map so each action bar has a width to measure that is not derived from
         its own content, which is what makes it latch into the collapsed state. -->
    <div
      class="brouter-map__layer position-absolute top-0 start-0 end-0 d-flex align-items-start justify-content-between p-5 pe-none"
    >
      <div class="d-flex flex-column align-items-start gap-4 pe-auto">
        <app-map-toolbar
          class="w-100"
          [readonlyMode]="readonlyMap()"
          [beelineEnabled]="beelineMode()"
          [drawEnabled]="drawMode()"
          [elevationEnabled]="showElevation()"
          [dataTableEnabled]="showDataTable()"
          [distanceMarkersEnabled]="showDistanceMarkers()"
          [routeQualityEnabled]="showRouteQuality()"
          (toggleDraw)="toggleDrawMode()"
          (toggleBeeline)="toggleBeelineMode()"
          (toggleElevation)="toggleElevation()"
          (toggleDataTable)="toggleDataTable()"
          (toggleDistanceMarkers)="toggleDistanceMarkers()"
          (toggleRouteQuality)="toggleRouteQuality()"
          (exportFile)="showExportDialog.set(true)"
          (importFile)="showLoaderDialog.set(true)"
          (reverseRoute)="routeEditor.reverse()"
          (deleteLastPoint)="routeEditor.deleteLastPoint()"
          (clearRoute)="clearRequested.emit()"
          (exportToUi)="exportRequested.emit()"
          (editRoute)="editRequested.emit()"
        />
        <app-map-search class="w-100" (resultSelected)="onSearchResult($event)" />
      </div>

      <app-map-view-controls
        class="flex-fill d-flex pe-none"
        (zoomIn)="zoomIn()"
        (zoomOut)="zoomOut()"
      />
    </div>

    <div
      class="brouter-map__layer position-absolute bottom-0 start-0 end-0 mx-5 mb-8 d-flex flex-column gap-4 pe-none"
    >
      @if (showDataTable() && hasTrack()) {
        <app-route-data-table
          class="pe-auto"
          [segments]="routeEditor.segments()"
          (rowHovered)="highlightPoint($event)"
          (closed)="toggleDataTable()"
        />
      }
      @if (showElevation() && hasTrack()) {
        <app-elevation-chart
          class="pe-auto"
          [track]="routeEditor.trackLatLngs()"
          [elevations]="routeEditor.trackElevations()"
          (pointHovered)="highlightPoint($event)"
          (closed)="toggleElevation()"
        />
      }
      <app-stats-footer class="pe-auto" [stats]="stats()" />
    </div>
  } @else {
    <div
      class="brouter-map__layer brouter-map__overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    >
      <si-loading-spinner />
    </div>
  }

  @if (isRouting()) {
    <output
      class="brouter-map__layer card elevation-2 position-absolute top-0 start-50 translate-middle-x mt-5 flex-row align-items-center gap-4 py-3 px-5"
      aria-live="polite"
    >
      <si-loading-spinner class="brouter-map__status-spinner" />
      {{ 'BROUTER_MAP.ROUTING' | translate }}
    </output>
  }

  @if (errorMessage(); as routingError) {
    <si-inline-notification
      class="brouter-map__layer position-absolute bottom-0 start-0 end-0 m-5"
      severity="danger"
      [heading]="'BROUTER_MAP.ROUTING_FAILED' | translate"
      [message]="routingError"
    />
  }

  @if (showExportDialog()) {
    <button
      type="button"
      class="brouter-map__layer brouter-map__backdrop position-absolute top-0 start-0 w-100 h-100 border-0 p-0"
      [attr.aria-label]="'SHARED.CLOSE' | translate"
      (click)="showExportDialog.set(false)"
    ></button>
    <dialog
      open
      class="brouter-map__layer brouter-map__dialog card elevation-3 position-absolute top-50 start-50 translate-middle overflow-hidden p-0 border-0"
    >
      <app-export-dialog
        [segments]="routeEditor.segments()"
        [waypoints]="routeEditor.waypoints()"
        [hasBeeline]="stats().hasBeeline"
        (closed)="showExportDialog.set(false)"
      />
    </dialog>
  }

  @if (showLoaderDialog()) {
    <button
      type="button"
      class="brouter-map__layer brouter-map__backdrop position-absolute top-0 start-0 w-100 h-100 border-0 p-0"
      [attr.aria-label]="'SHARED.CLOSE' | translate"
      (click)="showLoaderDialog.set(false)"
    ></button>
    <dialog
      open
      class="brouter-map__layer brouter-map__dialog card elevation-3 position-absolute top-50 start-50 translate-middle overflow-hidden p-0 border-0"
    >
      <app-track-loader-dialog
        (trackLoaded)="onTrackLoaded($event)"
        (closed)="showLoaderDialog.set(false)"
      />
    </dialog>
  }
</div>
